import React from 'react';
import { connect } from 'react-redux';
import { CFCProps } from 'types';
import { RootState } from 'redux/root.reducer';
import { getFullAddress } from 'utilities/helper.util';
import { SkeletonText, Button } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';

const ConfirmationPanel: React.FC<Props> = ({
  address,
  cancelEnquiryHandler,
  confirmDraw
}) => {
  return (
    <div className="draw-confirmation-panel">
      <div className="address-container">
        <div className="address-heading">Approximate address</div>
        {address ? (
          <div className="address-body">{getFullAddress(address)}</div>
        ) : (
          <SkeletonText />
        )}
      </div>
      <div className="button-container">
        <Button kind="tertiary" onClick={() => cancelEnquiryHandler(false)}>
          Draw again
        </Button>
        <Button renderIcon={ArrowRight16} onClick={() => confirmDraw()}>
          Continue
        </Button>
      </div>
    </div>
  );
};

type OwnProps = {
  cancelEnquiryHandler: Function;
  confirmDraw: Function;
};

const mapStateToProps = ({ lodgeEnquiryCache, enquiresCache }: RootState) => ({
  address: lodgeEnquiryCache?.address || enquiresCache?.data?.enquiry?.Address
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(ConfirmationPanel));
